import { Divider, Icon, Typography } from "@mui/material";
import React from "react";
import classes from "./CurrencyList.module.css";
import Brightness1Icon from "@mui/icons-material/Brightness1";

const CurrencyList = ({ name, price }) => {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.itemsContainer}>
          {/* <Brightness1Icon /> */}
          <p className={classes.text}>{name}</p>
          <p className={classes.text} style={{ marginRight: 80 }}>{price}</p>

        </div>
      </div>
      <Divider sx={{ color: "#080B2A", width: "75%", fontWeight: 600 }} />
    </>
  );
};

export default CurrencyList;
